import React from 'react';

const GroupWrapper = ({ children }) => (
  <div className="form-inline">
    {children}
  </div>
);

export default GroupWrapper;



// WEBPACK FOOTER //
// ./foody/src/components/Common/GroupWrapper.jsx